import React, { lazy, Suspense, useState } from "react";
import { sampleUsers, Categorytabs } from "./Data";
import Tabs from "./Tabs";

const CategoryManagement = lazy(() => import("./CategoryManagement"));
const CategoryRegistrations = lazy(() => import("./CategoryRegistrations"));

export default function CategoryManagementLandingPageIndex() {
  const [activeTab, setActiveTab] = useState(0);
  const tabLoadingFallback = (
    <div
      style={{
        marginTop: 16,
        padding: 20,
        borderRadius: 8,
        background: "#ffffff",
        color: "#666",
      }}
    >
      Loading...
    </div>
  );

  return (
    <div
      style={{
        borderRadius: 8,
        padding: 32,
        // margin: "84px 40px 100px 40px",
        minHeight: "calc(100vh - 124px)",
        boxSizing: "border-box",
        boxShadow: "0 2px 12px rgba(0,0,0,0.04)",
        display: "block",
      }}
      className="bg-[#bb1ccc]/5"
    >
      <Tabs activeTab={activeTab} setActiveTab={setActiveTab} tabs={Categorytabs} />

     
      <Suspense fallback={tabLoadingFallback}>
        {activeTab === 0 && (
          <>
            <CategoryManagement sampleUsers={sampleUsers} />
          </>
        )}

        {activeTab === 1 && (
          <>
            <CategoryRegistrations />
          </>
        )}
      </Suspense>

      
    </div>
  );
}
